const allExtraescolares = [
  {
    slug: "dibujo",
    label: "Creatividad artes plásticas",
    shortLabel: "Creatividad artes plásticas",
    category: "Creatividad visual",
    level: "Grupo único",
    href: "/cursos-especializados/dibujo",
    image:
      "https://images.unsplash.com/photo-1513364776144-60967b0f800f?auto=format&fit=crop&w=1400&q=80",
    summary:
      "Taller de dibujo con técnicas secas para aprender a observar, controlar la línea, trabajar valores y construir imágenes con intención.",
    description:
      "El taller se plantea como un recorrido práctico por técnicas secas. Empieza con una base común de lenguaje visual y observación, y avanza por grafito, carboncillo, sepias, pasteles y lápices de color. Cada técnica se trabaja en dos sesiones para que el alumnado pueda experimentar, corregir y cerrar piezas con más criterio.",
    content: [
      "Introducción al dibujo: línea, forma, proporción, observación y ejercicios de trazo libre.",
      "Grafito: tipos de lápiz, presión, texturas, claroscuro, degradados y volumen.",
      "Carboncillo y sepias: mancha, borrado, figura-fondo, contraluz, aguadas, luz lateral y composición.",
      "Pasteles y lápices de color: capas, difuminado, saturación, mezcla óptica y proyecto personal final.",
    ],
    outcomes: [
      "Más seguridad para observar, encajar y representar volumen.",
      "Conocimiento práctico de varias técnicas secas y cuándo usar cada una.",
      "Una serie de ejercicios y una pieza personal integrando lo aprendido.",
    ],
    practical: [
      { label: "Edades", value: "A partir de 6 años" },
      { label: "Horas semanales", value: "1,5 horas semanales" },
      { label: "Ratio", value: "Máximo 8 alumnos" },
      { label: "Duración", value: "Curso escolar completo, de septiembre a junio" },
      { label: "Materiales", value: "Proporcionados por el centro" },
      { label: "Horario", value: "Martes y jueves a las 17:30" },
      { label: "Precio", value: "75 € al mes" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
    roadmap: [
      {
        period: "Inicio de curso",
        title: "Base de observación",
        text: "Presentación del grupo y materiales. Lenguaje visual básico: línea, forma y proporción. Ejercicios de observación, dibujo ciego y trazo libre para soltar la mano.",
      },
      {
        period: "Primer bloque",
        title: "Grafito y volumen",
        text: "Tipos de lápiz, presión, línea y texturas. Claroscuro, degradados y representación de volumen en formas simples.",
      },
      {
        period: "Segundo bloque",
        title: "Carboncillo expresivo",
        text: "Mancha, trazo expresivo y borrado como herramienta. Trabajo de figura y espacio, proporciones, contraluz y relación fondo-figura.",
      },
      {
        period: "Tercer bloque",
        title: "Sepias y valor cálido",
        text: "Línea cargada y sutil, aguada opcional, composición, luz lateral y detalle aplicado a retrato o naturaleza muerta.",
      },
      {
        period: "Cuarto bloque",
        title: "Pasteles y color",
        text: "Capas, difuminado, papel de color, luz, color local y uso del fijador en paisaje o bodegón.",
      },
      {
        period: "Cierre de curso",
        title: "Lápices de color y proyecto final",
        text: "Capas, saturación, presión y mezcla óptica. Desarrollo de un proyecto personal que integre técnicas aprendidas, revisión y cierre del proceso.",
      },
    ],
  },
  {
    slug: "interpretacion",
    label: "Interpretación",
    shortLabel: "Interpretación",
    category: "Expresión escénica",
    level: "Grupo único",
    href: "/cursos-especializados/interpretacion",
    image:
      "https://images.unsplash.com/photo-1507676184212-d03ab07a01bf?auto=format&fit=crop&w=1400&q=80",
    summary:
      "Juego escénico, voz, cuerpo, improvisación y construcción de escenas para ganar presencia y herramientas expresivas.",
    description:
      "Interpretación propone un trabajo escénico progresivo en un entorno cuidado. Se entrenan escucha, presencia, imaginación, voz, cuerpo, emoción, improvisación y construcción colectiva de escenas.",
    content: [
      "Improvisación, escucha activa y respuesta escénica.",
      "Trabajo corporal, voz, ritmo y presencia.",
      "Creación de personajes y pequeñas escenas.",
      "Lectura dramática y muestras internas de proceso.",
    ],
    outcomes: [
      "Más confianza para expresarse ante otros.",
      "Mejor conciencia corporal y comunicativa.",
      "Herramientas para crear y sostener escenas en grupo.",
    ],
    practical: [
      { label: "Edades", value: "A partir de 6 años" },
      { label: "Horas semanales", value: "1,5 horas semanales" },
      { label: "Ratio", value: "Máximo 8 alumnos" },
      { label: "Duración", value: "Curso escolar completo, de septiembre a junio" },
      { label: "Precio", value: "80 € al mes" },
      { label: "Horario", value: "Consultar disponibilidad" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
  },
  {
    slug: "programacion-iniciacion",
    label: "Programación básica",
    shortLabel: "Programación básica",
    category: "Tecnología",
    level: "Iniciación",
    href: "/cursos-especializados/programacion-iniciacion",
    image:
      "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?auto=format&fit=crop&w=1400&q=80",
    summary:
      "Fundamentos prácticos de programación para aprender haciendo: entorno de desarrollo, Git, código limpio, testing, APIs y bases de datos.",
    description:
      "Programación de iniciación toma como base el bloque de fundamentos del itinerario anual. Cada sesión parte de una tarea real y termina con algo funcionando, explorado o resuelto. La teoría se introduce cuando hace falta para avanzar: configurar el entorno, escribir código claro, usar Git, probar, construir una API sencilla y conectar datos.",
    content: [
      "Entorno profesional de trabajo: IDE, terminal, repositorios, Git y GitHub.",
      "Clean Code, documentación, nombres claros, docstrings y hábitos de código mantenible.",
      "Python 3, tipado, linters, analizadores estáticos, testing con PyTest y pruebas de integración.",
      "Fundamentos HTTP/JSON, APIs REST con FastAPI, SQL y conexión con bases de datos mediante ORM.",
    ],
    outcomes: [
      "Comprensión del flujo básico de trabajo de un desarrollador: escribir, versionar, probar y mejorar.",
      "Capacidad para construir una API sencilla y conectar lógica de negocio con datos.",
      "Primeros hábitos profesionales: commits descriptivos, documentación útil, tests y revisión de errores.",
    ],
    practical: [
      { label: "Edades", value: "A partir de 6 años" },
      { label: "Duración", value: "Curso escolar completo, de septiembre a junio" },
      { label: "Horas semanales", value: "2 horas semanales" },
      { label: "Ratio", value: "Máximo 8 alumnos" },
      { label: "Formato", value: "Modalidad presencial; opción online disponible bajo consulta específica" },
      { label: "Objetivos", value: "Entendimiento de un flujo de desarrollo y sus herramientas" },
      { label: "Herramientas", value: "IDE moderno, Git/GitHub, Python 3, PyTest, FastAPI, SQL y SQLAlchemy" },
      { label: "Precio", value: "85 € al mes" },
      { label: "Horario", value: "Presencial: martes y jueves a las 18:30; modalidad online bajo consulta de disponibilidad" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
    onlineNotice: {
      title: "Modalidad online disponible",
      text: "Además de los grupos presenciales, existe la posibilidad de formar grupo online de Programación. Indícalo en el formulario para que podamos orientarte.",
      cta: "Preguntar por Programación online",
    },
    roadmapIntro:
      "Una progresión anual para entender el flujo completo de desarrollo: preparar el entorno, construir proyectos, probarlos, trabajar con datos y presentar soluciones con autonomía.",
    roadmap: [
      {
        period: "Primer trimestre",
        title: "Fundamentos y herramientas",
        text: "Primer contacto con el entorno de desarrollo, terminal, Git, GitHub, estructura de proyectos, lectura de errores y hábitos básicos para escribir código claro.",
      },
      {
        period: "Segundo trimestre",
        title: "Proyectos y lógica aplicada",
        text: "Construcción de pequeños proyectos guiados para trabajar lógica, funciones, organización del código, pruebas, depuración y mejora progresiva.",
      },
      {
        period: "Tercer trimestre",
        title: "Datos, servicios y cierre",
        text: "Introducción a datos, APIs y servicios sencillos. Integración de piezas, revisión del flujo completo de desarrollo y presentación de un proyecto final adaptado al nivel del grupo.",
      },
    ],
  },
  {
    slug: "programacion-avanzado",
    label: "Programación avanzada",
    shortLabel: "Programación avanzada",
    category: "Tecnología",
    level: "Avanzado",
    href: "/cursos-especializados/programacion-avanzado",
    image:
      "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?auto=format&fit=crop&w=1400&q=80",
    summary:
      "Curso anual avanzado para trabajar como en un entorno real, con tres eventos diferenciales: visita a empresa, hackathon y preparación de certificación cloud.",
    description:
      "El programa avanzado se organiza como un itinerario anual de desarrollo de software. La teoría aparece cuando hace falta para resolver una tarea real: configurar repositorios, escribir código mantenible, probarlo, desplegarlo y defenderlo en equipo. La propuesta se diferencia por conectar el aprendizaje con experiencias concretas: visitar una empresa real de software, preparar y participar en un hackathon, y trabajar contenidos orientados a una certificación cloud.",
    content: [
      "Primer trimestre: fundamentos profesionales, Git, Clean Code, testing, APIs, bases de datos y visita a una empresa real de software.",
      "Segundo trimestre: Docker, CI/CD, patrones de diseño, metodología Agile, trabajo en equipo y preparación para participar en un hackathon.",
      "Tercer trimestre: preparación de certificación cloud con servicios AWS, laboratorios, simulacros, estrategia de examen y Demo Day.",
      "Trabajo con herramientas reales: VS Code o IntelliJ, GitHub/GitLab, Python, TypeScript, Postman, Jest/PyTest, Docker y entornos cloud.",
    ],
    outcomes: [
      "Comprensión de cómo se trabaja en una empresa de software y qué roles existen: backend, frontend, DevOps y QA.",
      "Experiencia en trabajo por equipos, presión de tiempo, metodología de hackathon y presentación técnica.",
      "Preparación inicial para afrontar una certificación cloud y seguir profundizando en desarrollo profesional.",
    ],
    practical: [
      { label: "Edades", value: "A partir de 14 años o a partir de cierto nivel; consulta si eres menor" },
      { label: "Duración", value: "Curso escolar completo, de septiembre a junio" },
      { label: "Horas semanales", value: "2 horas semanales" },
      { label: "Ratio", value: "Máximo 8 alumnos" },
      { label: "Formato", value: "Modalidad presencial; opción online disponible bajo consulta específica" },
      { label: "Eventos", value: "Visita a empresa real, participación en hackathon y preparación de certificación AWS Certified Developer" },
      { label: "Conocimientos previos", value: "Necesarios conocimientos previos de programación" },
      { label: "Requisitos", value: "Equipo con IDE moderno, Git, Docker, Python/Node.js y capacidad para trabajar con contenedores" },
      { label: "Precio", value: "95 € al mes" },
      { label: "Horario", value: "Presencial: martes y jueves a las 19:30; modalidad online bajo consulta de disponibilidad" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
    onlineNotice: {
      title: "Modalidad online disponible",
      text: "También se puede consultar por grupo online de Programación avanzada. La organización del grupo dependerá de nivel, disponibilidad y número de participantes.",
      cta: "Preguntar por Programación online",
    },
    roadmapIntro:
      "Un recorrido anual con tres experiencias centrales: ver cómo se trabaja en una empresa tecnológica, competir construyendo en equipo y preparar una certificación cloud.",
    roadmap: [
      {
        period: "Primer trimestre",
        title: "Fundamentos y visita a empresa",
        text: "Trabajo sobre entorno profesional, Git, Clean Code, tipado, testing, APIs y bases de datos. El trimestre culmina con la preparación y visita a una empresa real de software para conocer roles, equipos y flujos de trabajo.",
      },
      {
        period: "Segundo trimestre",
        title: "Hackathon y desarrollo en equipo",
        text: "Docker, CI/CD, patrones, APIs externas, seguridad aplicada y metodología Agile. El objetivo es preparar una participación en hackathon con roles claros, presión de tiempo y presentación de soluciones.",
      },
      {
        period: "Tercer trimestre",
        title: "Certificación cloud y Demo Day",
        text: "Preparación orientada a AWS Certified Developer: servicios cloud, serverless, seguridad, monitorización, laboratorios y simulacros. Cierre con Demo Day y presentación del mayor logro del curso.",
      },
    ],
  },
  {
    slug: "produccion-musical",
    aliases: ["composicion-musical"],
    label: "Producción musical",
    shortLabel: "Producción musical",
    category: "Música y creación",
    level: "Grupo único",
    href: "/cursos-especializados/produccion-musical",
    image:
      "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?auto=format&fit=crop&w=1400&q=80",
    summary:
      "Curso práctico de producción musical con Ableton Live para crear un tema propio desde cero y terminarlo mezclado y exportado.",
    description:
      "Producción musical está diseñado para alumnado que quiere crear música de verdad, no solo hacer ejercicios. No hace falta experiencia previa ni teoría musical: cada participante aprende a usar Ableton Live para transformar una idea en una pieza completa, trabajando ritmo, armonía, melodía, estructura, mezcla y acabado final.",
    content: [
      "Fundamentos de Ableton Live: interfaz, proyectos, clips, estructura y flujo de trabajo.",
      "Programación de baterías, líneas de bajo, melodías, piano roll, instrumentos virtuales y grabación de ideas.",
      "Construcción del tema personal, decisiones de arreglo y adaptación a distintos estilos musicales.",
      "Mezcla, ecualización, compresión, master básico y exportación final del audio.",
    ],
    outcomes: [
      "Un tema musical propio producido, mezclado y exportado.",
      "Autonomía para iniciar nuevos proyectos en Ableton Live.",
      "Comprensión práctica de ritmo, armonía, estructura, mezcla y acabado final.",
    ],
    practical: [
      { label: "Edades", value: "A partir de 14 años o a partir de cierto nivel; consulta si eres menor" },
      { label: "Horas semanales", value: "2 horas semanales" },
      { label: "Ratio", value: "Máximo 8 alumnos" },
      { label: "Duración", value: "Curso escolar completo, de septiembre a junio" },
      { label: "Horario", value: "Viernes de 17:30 a 19:30" },
      { label: "Requisitos", value: "Ordenador portátil, Ableton Live y auriculares con cable" },
      { label: "Precio", value: "110 € al mes" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
  },
  {
    slug: "matematicas-iniciacion",
    label: "Iniciación a pensamiento lógico matemático",
    shortLabel: "Iniciación a pensamiento lógico matemático",
    category: "Pensamiento lógico",
    level: "A partir de 10 años",
    href: "/cursos-especializados/matematicas-iniciacion",
    image:
      "/images/cursos/imagen_taller_matematicas.png",
    summary:
      "Retos que parecen imposibles, estrategias ganadoras, códigos secretos, trucos matemáticos y problemas para pensar de otra manera.",
    description:
      "Esta extraescolar no es refuerzo escolar. Es un laboratorio de pensamiento para niños y niñas de mentes inquietas: resolver retos que parecen imposibles, descubrir estrategias ganadoras de juegos, descifrar códigos secretos, medir infinitos y entender trucos matemáticos. El objetivo es claro: pensamiento lógico, razonamiento matemático, creatividad, resolución de problemas y pensamiento crítico.",
    content: [
      "Retos de ingenio, patrones, trucos matemáticos y problemas que invitan a buscar atajos inteligentes.",
      "Estrategias ganadoras de juegos, razonamiento lógico y primeras demostraciones explicadas de forma accesible.",
      "Códigos secretos, probabilidad sorprendente, cumpleaños compartidos, grafos, mapas y redes.",
      "Ideas grandes contadas con lenguaje cercano: infinitos, decisiones justas y pequeñas investigaciones matemáticas.",
    ],
    outcomes: [
      "Una relación más rica, creativa y menos mecánica con las matemáticas.",
      "Más autonomía para enfrentarse a problemas abiertos, probar estrategias y no rendirse al primer intento.",
      "Capacidad para explicar, justificar y discutir soluciones con pensamiento lógico y crítico.",
    ],
    practical: [
      { label: "Edades", value: "A partir de 10 años" },
      { label: "Duración", value: "Curso escolar completo, de septiembre a junio" },
      { label: "Horas semanales", value: "2 horas semanales" },
      { label: "Ratio", value: "Máximo 8 alumnos" },
      { label: "Formato", value: "Curso flexible, adaptado al nivel real e intereses del grupo" },
      { label: "Precio", value: "90 € al mes" },
      { label: "Horario", value: "Martes y jueves a las 18:30" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
    examplesTitle: "Una pequeña muestra",
    examplesHeading: "Primeros retos",
    examplesIntro:
      "Algunos problemas se entienden en un minuto, pero abren conversaciones matemáticas muy potentes.",
    examples: [
      "Tienes que sumar 1+2+3+4…+20.000 y tienes escasos minutos para hacerlo. ¿Se te ocurre una manera de lograrlo?",
      "Se colocan 21 cerillas sobre la mesa. En cada turno, cada jugador puede retirar 1, 2 o 3 cerillas. Pierde quien se lleva la última. ¿Existe una estrategia para ganar siempre?",
      "En una clase hay 30 personas. ¿Es probable que haya dos que cumplan años exactamente el mismo día?",
      "Descifra el mensaje: JXYJ HFRGNT IJ QJYWFX JX FSYNLZT, UJWT KZSHNTSF GNJS UFWF HTSKZSINW F VZNJS NSYJSYF QJJW XNS UJWRNXT.",
    ],
  },
  {
    slug: "matematicas-avanzado",
    label: "Pensamiento lógico matemático avanzado",
    shortLabel: "Pensamiento lógico matemático avanzado",
    category: "Pensamiento lógico",
    level: "A partir de 14 años o nivel avanzado",
    href: "/cursos-especializados/matematicas-avanzado",
    image:
      "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?auto=format&fit=crop&w=1400&q=80",
    summary:
      "Un espacio de pensamiento avanzado para adolescentes y adultos: demostraciones, estrategia, combinatoria, probabilidad, criptografía, decisiones e infinitos.",
    description:
      "Matemáticas avanzadas es una propuesta de enriquecimiento para adolescentes y adultos que disfrutan pensando con profundidad. No se trata de repasar contenidos escolares, sino de explorar problemas no rutinarios, demostrar ideas, detectar patrones, discutir estrategias y usar las matemáticas para entender juegos, redes, azar, códigos, decisiones e infinitos.",
    content: [
      "Demostraciones, contraejemplos, inducción, reducción al absurdo, invariantes y razonamiento lógico.",
      "Combinatoria, principio del palomar, teoría de números, sucesiones, primos, divisibilidad y conjeturas.",
      "Teoría de juegos, estrategias ganadoras, grafos, redes, probabilidad contraintuitiva y toma de decisiones.",
      "Criptografía, códigos secretos, sistemas de votación, repartos justos, optimización, paradojas e infinitos.",
    ],
    outcomes: [
      "Mayor madurez argumentativa para justificar por qué una idea funciona o por qué no puede funcionar.",
      "Estrategias de resolución para problemas complejos, abiertos y sin método evidente.",
      "Pensamiento crítico y matemático aplicable a decisiones, modelos, juegos, datos y situaciones reales.",
    ],
    practical: [
      { label: "Edades", value: "A partir de 14 años o a partir de cierto nivel; consulta si eres menor" },
      { label: "Duración", value: "Curso escolar completo, de septiembre a junio" },
      { label: "Horas semanales", value: "2 horas semanales" },
      { label: "Ratio", value: "Máximo 8 alumnos" },
      { label: "Formato", value: "Curso flexible, con adaptación continua a intereses y evolución del grupo" },
      { label: "Precio", value: "100 € al mes" },
      { label: "Horario", value: "Martes y jueves a las 19:30" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
  },
  {
    slug: "ajedrez",
    label: "Ajedrez",
    shortLabel: "Ajedrez",
    category: "Estrategia",
    level: "Iniciación y perfeccionamiento",
    href: "/cursos-especializados/ajedrez",
    image:
      "https://images.unsplash.com/photo-1529699211952-734e80c4d42b?auto=format&fit=crop&w=1400&q=80",
    summary:
      "Estrategia, táctica, cálculo, toma de decisiones y análisis de partidas con enfoque progresivo.",
    description:
      "Ajedrez trabaja pensamiento estratégico, memoria de trabajo, anticipación, gestión del error y toma de decisiones. El nivel se ajusta al grupo, combinando teoría breve, posiciones tácticas, partidas y análisis.",
    content: [
      "Principios de apertura, medio juego y finales básicos.",
      "Táctica: clavadas, dobles ataques, descubiertas, mates y cálculo.",
      "Análisis de partidas propias y posiciones históricas.",
      "Juego guiado, retos por niveles y pequeñas competiciones internas.",
    ],
    outcomes: [
      "Mejor planificación y visión táctica.",
      "Hábito de analizar decisiones sin quedarse en el resultado.",
      "Autonomía para estudiar y mejorar partidas.",
    ],
    practical: [
      { label: "Edades", value: "A partir de 6 años" },
      { label: "Horas semanales", value: "2 horas semanales" },
      { label: "Ratio", value: "Máximo 8 alumnos" },
      { label: "Duración", value: "Curso escolar completo, de septiembre a junio" },
      { label: "Precio", value: "35 € al mes (25 € para socios de The Box)" },
      { label: "Horario", value: "Perfeccionamiento: lunes a las 17:30. Iniciación: miércoles a las 17:30" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
  },
  {
    slug: "hacking-etico",
    aliases: ["ciberseguridad-hacking-etico"],
    label: "Hacking ético",
    shortLabel: "Hacking ético",
    category: "Tecnología responsable",
    level: "Grupo único",
    href: "/cursos-especializados/hacking-etico",
    image:
      "https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=1400&q=80",
    summary:
      "Curso anual de hacking ético para aprender ciberseguridad haciendo: laboratorios controlados, CTF, visita a empresa y preparación eJPT.",
    description:
      "Ciberseguridad se plantea con un enfoque 100% práctico, responsable y legal. Cada sesión parte de un reto, herramienta o laboratorio, siempre en entornos controlados y autorizados. El recorrido ayuda a entender cómo se protegen los sistemas, cómo piensa un atacante ético y qué salidas profesionales existen en áreas como SOC, pentesting, GRC, forense o threat intelligence.",
    content: [
      "Fundamentos de entorno y red: terminal Kali, permisos, usuarios, escaneo, captura de tráfico, contraseñas, hashes y privacidad digital.",
      "Seguridad web y análisis: peticiones HTTP, Burp Suite, vulnerabilidades web en laboratorio, OSINT responsable y primeros retos CTF.",
      "Competición y trabajo en equipo: metodología CTF, scripting con Python/Bash, criptografía, forense digital, reversing básico y simulacros.",
      "Preparación eJPT: reconocimiento, enumeración, explotación en laboratorio, post-explotación, informes profesionales y estrategia de examen.",
    ],
    outcomes: [
      "Criterio técnico y ético para entender la seguridad ofensiva y defensiva sin salir de entornos autorizados.",
      "Soltura inicial con laboratorios, retos CTF, documentación de hallazgos y metodología de pentesting.",
      "Orientación clara sobre áreas profesionales de ciberseguridad y una base práctica para continuar hacia eJPT.",
    ],
    practical: [
      { label: "Edades", value: "A partir de 14 años o a partir de cierto nivel; consulta si eres menor" },
      { label: "Duración", value: "Curso escolar completo, de septiembre a junio" },
      { label: "Horas semanales", value: "2 horas semanales" },
      { label: "Ratio", value: "Máximo 8 alumnos" },
      { label: "Formato", value: "Presencial" },
      { label: "Herramientas", value: "Kali Linux, TryHackMe, HackTheBox, INE Labs, PicoCTF, CTFd, Burp Suite, Metasploit y Wireshark" },
      { label: "Eventos", value: "Visita a empresa de ciberseguridad, CTF/hackathon externo, preparación eJPT y Demo Day" },
      { label: "Precio", value: "120 € al mes" },
      { label: "Horario", value: "Martes y jueves de 19:30 a 20:30, o sábados de 10:00 a 12:00" },
      { label: "Duración de las sesiones", value: "1 hora los martes y jueves, o una sesión de 2 horas los sábados" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
    roadmapIntro:
      "Un recorrido anual con tres momentos claros: construir fundamentos, competir en retos de ciberseguridad y preparar una certificación de entrada al sector.",
    roadmap: [
      {
        period: "Primer trimestre",
        title: "Fundamentos y visita profesional",
        text: "Trabajo con terminal, redes, contraseñas, OSINT, privacidad y seguridad web en laboratorios controlados. El trimestre conecta con una visita a empresa para conocer roles reales como SOC, pentesting, GRC o forense.",
      },
      {
        period: "Segundo trimestre",
        title: "CTF y competición",
        text: "Metodología de retos, trabajo en equipo, scripting, criptografía, esteganografía, forense digital y reversing básico. Preparación para participar en un CTF o hackathon externo con estrategia y roles definidos.",
      },
      {
        period: "Tercer trimestre",
        title: "Certificación eJPT y Demo Day",
        text: "Preparación orientada a eJPT: reconocimiento, enumeración, explotación en laboratorio, escalada, pivoting, reporting y simulacros. Cierre con presentación final y recursos para seguir aprendiendo.",
      },
    ],
  },
  {
    slug: "filosofia-para-ninos",
    label: "Filosofía para niños",
    shortLabel: "Filosofía para niños",
    category: "Pensamiento crítico",
    level: "Grupo único",
    href: "/cursos-especializados/filosofia-para-ninos",
    image:
      "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=1400&q=80",
    summary:
      "Un espacio para pensar, preguntar, argumentar y escuchar: dilemas, conversación guiada, creatividad y pensamiento crítico.",
    description:
      "Filosofía para Niños propone una comunidad de indagación donde las preguntas importan tanto como las respuestas. A partir de relatos, dilemas y situaciones cercanas, el grupo aprende a razonar, argumentar, escuchar y construir ideas propias con respeto.",
    content: [
      "Preguntas filosóficas adaptadas a la edad: identidad, justicia, libertad, verdad, amistad y convivencia.",
      "Conversación guiada, escucha activa, turnos de palabra y construcción colectiva de argumentos.",
      "Dilemas, relatos breves, juegos de pensamiento y pequeñas investigaciones.",
      "Herramientas para distinguir opiniones, razones, ejemplos, contraejemplos y conclusiones.",
    ],
    outcomes: [
      "Mayor claridad para expresar ideas y justificar puntos de vista.",
      "Escucha más activa y respeto por perspectivas diferentes.",
      "Pensamiento crítico, creatividad y confianza para formular buenas preguntas.",
    ],
    practical: [
      { label: "Edades", value: "A partir de 6 años" },
      { label: "Horas semanales", value: "2 horas semanales" },
      { label: "Ratio", value: "Máximo 8 alumnos" },
      { label: "Duración", value: "Curso escolar completo, de septiembre a junio" },
      { label: "Precio", value: "80 € al mes" },
      { label: "Horario", value: "Martes y jueves a las 17:30" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
  },
  {
    slug: "debate-y-oratoria",
    label: "Debate y oratoria",
    shortLabel: "Debate y oratoria",
    category: "Comunicación",
    level: "Grupo único",
    href: "/cursos-especializados/debate-y-oratoria",
    image:
      "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1400&q=80",
    summary:
      "Entrenamiento de comunicación oral para ordenar ideas, hablar en público, argumentar, debatir y responder con seguridad.",
    description:
      "Debate y oratoria trabaja la comunicación oral desde la práctica. El alumnado aprende a estructurar discursos, defender una postura, escuchar objeciones, responder con argumentos y ganar presencia ante un grupo.",
    content: [
      "Estructura del discurso: apertura, tesis, argumentos, ejemplos y cierre.",
      "Voz, ritmo, presencia, lenguaje corporal y gestión de nervios.",
      "Debate reglado, refutación, escucha activa y respuesta a preguntas.",
      "Preparación de intervenciones breves, exposición de ideas y feedback guiado.",
      "Preparación progresiva para participar en un torneo de debate como objetivo final del recorrido.",
    ],
    outcomes: [
      "Más seguridad al hablar en público.",
      "Mejor capacidad para ordenar ideas y defender argumentos.",
      "Escucha crítica, respuesta ágil y comunicación más clara.",
      "Preparación para participar en un torneo de debate.",
    ],
    practical: [
      { label: "Edades", value: "A partir de 6 años" },
      { label: "Horas semanales", value: "2 horas semanales" },
      { label: "Ratio", value: "Máximo 8 alumnos" },
      { label: "Duración", value: "Curso escolar completo, de septiembre a junio" },
      { label: "Precio", value: "80 € al mes" },
      { label: "Horario", value: "Consultar disponibilidad" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
  },
  {
    slug: "aprender-a-pensar",
    label: "Aprender a pensar",
    shortLabel: "Aprender a pensar",
    category: "Pensamiento y creatividad",
    level: "Dos grupos",
    href: "/cursos-especializados/aprender-a-pensar",
    image: "/images/cursos/aprendizaje-activo.jpg",
    summary: "Un espacio para explorar preguntas, comparar ideas y descubrir distintas formas de resolver un reto.",
    description: "Aprender a pensar propone juegos de razonamiento, preguntas abiertas y retos que ayudan a explicar ideas, buscar alternativas y reflexionar sobre cómo llegamos a una respuesta.",
    content: [
      "Juegos de razonamiento, patrones y estrategias.",
      "Retos abiertos para buscar y comparar distintas soluciones.",
      "Conversación guiada para explicar el propio proceso de pensamiento.",
    ],
    outcomes: [
      "Más flexibilidad para abordar problemas.",
      "Mayor claridad para explicar ideas y estrategias.",
      "Confianza para probar, revisar y aprender del error.",
    ],
    practical: [
      { label: "Precio", value: "75 € al mes" },
      { label: "Horario", value: "Martes y jueves: 18:00–19:00 y 19:00–20:00 (dos grupos)", },
      { label: "Duración", value: "Curso escolar completo, de septiembre a junio" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
  },
  {
    slug: "miercoles-con-jovenes",
    label: "Miércoles con jóvenes",
    shortLabel: "Miércoles con jóvenes",
    category: "Encuentro y conversación",
    level: "14–17 años",
    href: "/cursos-especializados/miercoles-con-jovenes",
    image: "/images/cursos/grupos-reducidos.jpg",
    summary: "Un encuentro semanal con Jana para jóvenes de 14 a 17 años.",
    description: "Un espacio participativo para conversar sobre intereses compartidos, intercambiar ideas y construir actividades con el grupo.",
    content: [
      "Conversación sobre intereses e inquietudes del grupo.",
      "Actividades participativas y propuestas elegidas con los jóvenes.",
      "Intercambio de ideas en un entorno cuidado.",
    ],
    outcomes: [
      "Un espacio propio de encuentro entre jóvenes.",
      "Más oportunidades para compartir intereses e ideas.",
      "Participación en la creación de las actividades.",
    ],
    practical: [
      { label: "Edades", value: "De 14 a 17 años" },
      { label: "Precio", value: "175 € al mes" },
      { label: "Horario", value: "Miércoles a las 18:30" },
      { label: "Referente", value: "Jana" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
  },
  {
    slug: "juegos-enriquecimiento",
    label: "Juegos de enriquecimiento",
    shortLabel: "Juegos de enriquecimiento",
    category: "Juegos y retos",
    level: "8–12 años",
    href: "/cursos-especializados/juegos-enriquecimiento",
    image: "/images/cursos/aprendizaje-activo.jpg",
    summary: "Juegos y retos de lógica, estrategia y creatividad para niños y niñas de 8 a 12 años.",
    description: "Una propuesta de juegos de enriquecimiento para resolver retos compartidos, probar estrategias y poner en común distintas soluciones.",
    content: [
      "Juegos de lógica y estrategia.",
      "Retos creativos y cooperativos.",
      "Puesta en común de estrategias y soluciones.",
    ],
    outcomes: [
      "Más recursos para resolver retos de forma creativa.",
      "Práctica de cooperación, estrategia y comunicación.",
      "Disfrute de juegos con profundidad y desafío.",
    ],
    practical: [
      { label: "Edades", value: "De 8 a 12 años" },
      { label: "Precio", value: "175 € al mes" },
      { label: "Horario", value: "Viernes de 18:30 a 20:00" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
  },
  {
    slug: "talleres-varios",
    label: "Talleres varios",
    shortLabel: "Talleres varios",
    category: "Talleres",
    level: "Convocatorias puntuales",
    href: "/cursos-especializados/talleres-varios",
    image: "/images/cursos/talleres-creativos.jpg",
    summary: "Talleres de distintas temáticas para descubrir propuestas nuevas los sábados.",
    description: "Una programación flexible de talleres y experiencias que permite probar iniciativas nuevas y anunciar cada convocatoria con su temática y condiciones.",
    content: [
      "Talleres de distintas temáticas.",
      "Nuevas propuestas que se anunciarán en cada convocatoria.",
      "Experiencias breves para descubrir intereses y habilidades.",
    ],
    outcomes: [
      "Explorar actividades nuevas.",
      "Descubrir intereses en formatos de taller.",
      "Participar en propuestas puntuales durante el curso.",
    ],
    practical: [
      { label: "Horario", value: "Sábados de 10:00 a 14:00" },
      { label: "Fechas, edades y precio", value: "Consultar cada convocatoria" },
      { label: "Lugar", value: "C/ del Poeta Rafael Morales 2, San Sebastián de los Reyes, Madrid" },
    ],
  },
];

export const extraescolares = allExtraescolares.filter((activity) => ![
  "interpretacion",
  "produccion-musical",
  "debate-y-oratoria",
].includes(activity.slug));

export const extraescolarRoutes = extraescolares.map(({ href, label, shortLabel, slug, level }) => ({
  href,
  label,
  shortLabel,
  slug,
  level,
}));

export function getExtraescolarBySlug(slug) {
  return extraescolares.find((activity) => activity.slug === slug || activity.aliases?.includes(slug));
}
